import { Component, Inject, OnInit } from "@angular/core";
import { Language } from "@bca-core/models/_enums";
import { AvoTrackingService } from "@bca-core/services/avo-tracking.service";
import { RouterService } from "@bca-core/services/router.service";
import { MessageType } from "@bca-shared/models/_enums";
import { APP_CONFIG, IAppConfiguration } from "@bca-shared/models/config";
import { IMessage } from "@bca-shared/models/message";
import * as appActions from "@bca-store/app.actions";
import { createAction } from "@bca-store/models/action-creator";
import { IRootState } from "@bca-store/store.reducers";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { filter } from "rxjs/operators";

@Component({
  selector: "bca-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  currentRoute$ = this._store$.pipe(select(({ app }) => app.currentRoute));
  message$ = this._store$.pipe(
    select(({ app }) => app.lastMessage),
    filter((message) => !message || message.type < MessageType.DEBUG),
  );

  constructor(
    private _store$: Store<IRootState>,
    private _routerService: RouterService,
    private _translate: TranslateService,
    private _avoTrackingService: AvoTrackingService,
    @Inject(APP_CONFIG) public config: IAppConfiguration,
  ) {
    const documentLanguage = document.documentElement.lang;
    this._translate.setDefaultLang(Language.DUTCH);
    this._translate.use(documentLanguage);
  }

  ngOnInit(): void {
    this._avoTrackingService.initializePageViewTracking();
    this._avoTrackingService.triggerInitialPageView();
  }


  onClose({ type }: IMessage): void {
    this._store$.dispatch(
      createAction(new appActions.DeleteMessage(), AppComponent),
    );
    if (type === MessageType.ERROR) {
      this._routerService.refreshPage(true, 250);
    }
  }
}
